import React, { Component, Fragment } from "react";
import styled from "styled-components";
import { connect } from "react-redux";

import { media } from "utils/style";
import { ENDPOINTS } from "utils/endpoints";
import { setA11yContent } from "../../NavigationHelper/actions";
import { fetchPageContent } from "../../DownloadAndDelete/actions";
import { checkNestedObject } from "utils/checkNestedObject";

import Header from "common-components/Header";
import RectangleLoader from "common-components/RectangleLoader";
import StyledLink from "common-components/StyledLink";

class WirelineSubAccount extends Component {
  state = {
    loading: true
  };

  componentDidMount() {
    this.props.fetchPageContent(ENDPOINTS.FETCH_WIRELINE_SUB_ACCOUNT_PAGE).then(() => {
      this.setState({ loading: false });
      if (checkNestedObject(this.props.pageContent, "sc_pagetitle")) {
        this.props.setA11yContent("wireline sub account", this.props.pageContent.sc_pagetitle);
      }
    });
  }

  render() {
    const { pageContent } = this.props;

    return (
      <Container>
        {this.state.loading ? (
          <RectangleLoader />
        ) : (
          <Fragment>
            <Header style={{ maxWidth: "525px" }}>{pageContent.section_title}</Header>
            <p style={{ maxWidth: "600px", margin: "40px 0 50px 0" }}>{pageContent.section_description}</p>
            <StyledLink linkType="anchor" href={ENDPOINTS.LOGOUT} background={pageContent.buttons[0].type}>
              {pageContent.buttons[0].text}
            </StyledLink>
          </Fragment>
        )}
      </Container>
    );
  }
}

const mapStateToProps = ({ pageContent: { wirelinesubaccount: pageContent } }) => ({
  pageContent
});

export default connect(
  mapStateToProps,
  { setA11yContent, fetchPageContent }
)(WirelineSubAccount);

const Container = styled.div`
  padding: 40px 20px 220px 20px;

  ${media.mobile`
    padding: 40px 16px;
  `}
`;
